<template>
  <section ref="target" class="container">
    <div v-drag-scroll class="filter-bar py-200 pl-100 flex gap-100">
      <LcButton
        v-for="price in prices"
        :key="price"
        class="filter-button"
        :class="{ 'filter-button--active': isActive(price) }"
        :icon="isActive(price) ? 'close' : undefined"
        icon-position="right"
        no-padding
        size="small"
        variant="raised"
        @click="emit('price:click', price)"
      >
        {{ formatMoney({ value: price, currency: 'USD' }, { fractionDigits: 0 }) }}
      </LcButton>
    </div>
  </section>
</template>

<script lang="ts" setup>
type Emits = {
  (e: 'price:click', prices: number): void
}

type Props = {
  activePrices?: readonly number[]
  prices?: readonly number[]
}

const emit = defineEmits<Emits>()

const { activePrices = [], prices = [] } = defineProps<Props>()

const isActive = (price: number) => activePrices.includes(price)
</script>

<style lang="scss" scoped>
.filter-button {
  min-width: 2.5rem;
  min-height: 2.5rem;
  padding: token('size/space/gap/none');
  border: token('size/border/100') solid token('color/border/primary/primary');
  border-radius: token('size/radius/m');
  background: token('color/background/primary/primary');
  box-shadow: none;
  transition: none;

  &--active {
    min-width: unset;
    padding: token('size/space/gap/none') token('size/space/gap/050') token('size/space/gap/none')
      token('size/space/gap/100');
    background: token('color/background/accent/info/info/bold');
    box-shadow: token('shadow/shadow/card/extrasmall');

    :deep(i:first-of-type) {
      margin: token('size/space/gap/none');
    }
  }
}
</style>
